import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { getLabelFromPriceRange } from "../FilterValue";
import formatPrice from "../../../helper/formatPrice";
import { Range } from "react-range";
import css from "../../../css/agents/slider.module.css";

const RANGE_DEFAULT = { min: 50000, max: 3000000 };

const PriceRange = (props) => {
    const getPropsValues = () => {
        return props.priceRange.value
            ? [props.priceRange.value.min, props.priceRange.value.max]
            : [RANGE_DEFAULT.min, RANGE_DEFAULT.max];
    };

    const [values, setValues] = useState(getPropsValues());

    useEffect(() => {
        setValues(getPropsValues());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.priceRange.value]);

    const handleFinalChange = (values) => {
        let priceRange = props.priceRange;

        priceRange.value = { min: values[0], max: values[1] };
        priceRange.label = getLabelFromPriceRange(priceRange.value);

        setValues(values);

        props.onChange(priceRange);
    };

    return (
        <Range
            step={10000}
            min={RANGE_DEFAULT.min}
            max={RANGE_DEFAULT.max}
            values={values}
            onChange={(values) => setValues(values)}
            onFinalChange={handleFinalChange}
            renderTrack={({ props, children }) => (
                <div {...props} className={css.track}>
                    {children}
                </div>
            )}
            renderThumb={({ props }) => (
                <div
                    {...props}
                    key={props.key}
                    className={css.thumb}
                    style={{
                        ...props.style,
                    }}
                >
                    <div className={css.tooltip}>
                        {formatPrice(values[props.key])}
                    </div>
                </div>
            )}
        />
    );
};

PriceRange.propTypes = {
    name: PropTypes.string.isRequired,
    priceRange: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default PriceRange;
